module.exports = __webpack_public_path__ + "static/media/server.19da8f89.svg";